import { useState } from 'react';

export const useTrigger = <T>(updateFunction: () => void, value: T) => {
  const [prevValue, setPrevValue] = useState(value);

  if (value !== prevValue) {
    setPrevValue(value);
    updateFunction();
  }
};
